<script setup lang="ts">
import { onMounted, onUnmounted, reactive, ref } from "vue";
import CopyLinkBtn from "../../../components/preview/CopyLinkBtn.vue";
import { locale } from "../../../locale";
import CustomVideo from "../../../components/CustomVideo.vue";
import { authState } from "../../../states/auth";
import { init } from "../../../states/media/state";
const copyState = ref(true);
onMounted(() => {
  init()
  copy();
});

const padding = 24;
const gap = 34;
const paddingBottom = 60;
const copy = () => {
  if (navigator.clipboard.writeText) {
    navigator.clipboard.writeText(window.location.href);
  }
  copyState.value = true;
  setTimeout(() => {
    copyState.value = false;
  }, 3000);
};

const size = reactive({
  width: 16 * 50,
  height: 9 * 50,
});

const startArea = ref<HTMLElement | null>(null);
const titleRef = ref<HTMLElement | null>(null);
let observer: ResizeObserver | null = null;
onMounted(() => {
  observer = new ResizeObserver((entries) => {
    const el = entries[0].target as HTMLElement;
    const w = el.clientWidth;
    const h = el.clientHeight;
    if (w === 0 || h === 0) return;
    const availableH =
      h -
      padding * 2 -
      2 * gap -
      paddingBottom -
      // button
      36 -
      (titleRef.value?.clientHeight || 0);
    const availableW = w - padding * 2;
    if (availableH * (16 / 9) > availableW) {
      size.width = availableW;
      size.height = availableW * (9 / 16);
    } else {
      size.width = availableH * (16 / 9);
      size.height = availableH;
    }
  });
  observer.observe(startArea.value!);
});
onUnmounted(() => {
  observer?.disconnect();
});
</script>
<template>
  <div
    ref="startArea"
    class="start-area"
    :style="{
      padding: `${padding}px`,
    }"
  >
    <div
      class="preview-block"
      :style="{
        gap: `${gap}px`,
        paddingBottom: `${paddingBottom}px`,
      }"
    >
      <div class="video-div">
        <CustomVideo
          ref="videoVue"
          :size="size"
          :user-id="authState.id"
          :avatar="authState.avatar"
          :displayed-name="authState.displayedName"
        />
      </div>
      <span ref="titleRef" class="title">{{ locale.invite }}</span>
      <CopyLinkBtn @click="copy" :state="copyState" />
    </div>
  </div>
</template>
<style scoped>
.start-area {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-block {
  max-width: 100%;
  border-radius: 8px;
  background: #292929;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: #dbdbdb;
  max-width: 370px;
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 123.964%;
  margin-left: 24px;
  margin-right: 24px;
}

.video-div {
  max-width: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
}

video {
  border-radius: 8px;
  max-width: 100%;
}
</style>
